import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;

let isInitialized = false;

export const initAnalytics = () => {
    if (!MIXPANEL_TOKEN) {
        console.warn("Mixpanel token is missing. Analytics will not be tracked.");
        return;
    }
    mixpanel.init(MIXPANEL_TOKEN, {
        autocapture: true,
        record_sessions_percent: 100,
    });
    isInitialized = true;
};

export const trackEvent = (eventName, properties = {}) => {
    if (!isInitialized) {
        console.warn(`Mixpanel not initialized. Skipping event: ${eventName}`);
        return;
    }
    mixpanel.track(eventName, properties);
};

export const identifyUser = (userId, traits = {}) => {
    if (!isInitialized) return;
    mixpanel.identify(userId);
    mixpanel.people.set(traits);
};

export const resetUser = () => {
    if (!isInitialized) return;
    mixpanel.reset();
};

